import {Tooltip} from '@components/common/tooltip/tooltip'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {TableUserInfo} from '../types'
import {useUsersTableStore} from '../users-table-store'
import {UserInfo} from './user-info'

export const UserTooltip = observer((props: {user: TableUserInfo}) => {
  const [state, store] = useUsersTableStore()
  return (
    <Tooltip
      onClick={e => {
        e.stopPropagation()
        store.toggleSelected(props.user.userId)
      }}
      placement="left"
      triggerTarget={state.userElements.get(props.user.userId)}
      content={<UserInfo user={props.user} />}
    >
      <div className="inline-block h-16"></div>
    </Tooltip>
  )
})
